<div class="banner d-none d-lg-flex" role="banner">
  <div class="container fantasy-banner">
    <h1>{{ 'games.page.pick.player.title' | translate }}</h1>

    <div class="d-flex align-items-center">
      <span class="text-white me-lg-3 me-1 font-size-12">Presented By: </span>
      <img class="sponsor-logo" src="assets/images/games/FMBanner.png" />
    </div>
  </div>
</div>

<fgb-fantasy-player-select [gameId]="id"></fgb-fantasy-player-select>
